import type { IconProps } from './IconProps';

export const PerformanceLabPhoneIcon = ({ className, style }: IconProps) => (
  <svg
    className={className}
    style={style}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8.82667 14.3867C10.7467 18.16 13.84 21.2533 17.6133 23.1733L20.5467 20.24C20.92 19.8667 21.44 19.76 21.9067 19.9067C23.4 20.4 25 20.6667 26.6667 20.6667C27.0203 20.6667 27.3594 20.8071 27.6095 21.0572C27.8595 21.3072 28 21.6464 28 22V26.6667C28 27.0203 27.8595 27.3594 27.6095 27.6095C27.3594 27.8595 27.0203 28 26.6667 28C20.6551 28 14.8897 25.6119 10.6389 21.3611C6.38809 17.1103 4 11.3449 4 5.33333C4 4.97971 4.14048 4.64057 4.39052 4.39052C4.64057 4.14048 4.97971 4 5.33333 4H10C10.3536 4 10.6928 4.14048 10.9428 4.39052C11.1929 4.64057 11.3333 4.97971 11.3333 5.33333C11.3333 7 11.6 8.6 12.0933 10.0933C12.24 10.56 12.1333 11.08 11.76 11.4533L8.82667 14.3867Z"
      fill="white"
    />
  </svg>
);
